export const BreadcrumbIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M53 150C53 146.686 55.6863 144 59 144H118C121.314 144 124 146.686 124 150C124 153.314 121.314 156 118 156H59C55.6863 156 53 153.314 53 150Z'
      fill='#A0AEC0'
    />
    <path
      d='M157 150C157 146.686 159.686 144 163 144H225C228.314 144 231 146.686 231 150C231 153.314 228.314 156 225 156H163C159.686 156 157 153.314 157 150Z'
      fill='#A0AEC0'
    />
    <path
      d='M264 150C264 146.686 266.686 144 270 144H341C344.314 144 347 146.686 347 150C347 153.314 344.314 156 341 156H270C266.686 156 264 153.314 264 150Z'
      fill='#38B2AC'
    />
    <path
      d='M144.805 139.204L138.712 161.843H135.323L141.417 139.204H144.805Z'
      fill='#A0AEC0'
    />
    <path
      d='M251.805 139.204L245.712 161.843H242.323L248.417 139.204H251.805Z'
      fill='#A0AEC0'
    />
  </svg>
)
